var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconQuestionMark = function SvgIconQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_black_24dp-2",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8544",
    "data-name": "Caminho 8544",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_17",
    "data-name": "Subtra\\xE7\\xE3o 17",
    d: "M-3975-1394a11,11,0,0,0-11,11,11,11,0,0,0,11,11,11,11,0,0,0,11-11A11,11,0,0,0-3975-1394Z",
    transform: "translate(3987.001 1395.001)",
    fill: "none",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8565",
    "data-name": "Caminho 8565",
    d: "M3.071.912H.353Q.342.326.342.2A4.756,4.756,0,0,1,.779-1.977,6.631,6.631,0,0,1,2.528-3.9a13.089,13.089,0,0,0,1.567-1.4,1.867,1.867,0,0,0,.394-1.151,1.94,1.94,0,0,0-.7-1.5,2.721,2.721,0,0,0-1.882-.624A2.85,2.85,0,0,0,0-7.915,3.461,3.461,0,0,0-1.054-5.932L-3.8-6.274A4.564,4.564,0,0,1-2.179-9.515a5.762,5.762,0,0,1,3.961-1.333A5.971,5.971,0,0,1,5.886-9.5a4.083,4.083,0,0,1,1.525,3.14,3.452,3.452,0,0,1-.56,1.876A12.286,12.286,0,0,1,4.457-2.073,4.569,4.569,0,0,0,3.279-.8,4.254,4.254,0,0,0,3.071.912ZM.353,4.942v-3h3v3Z",
    transform: "translate(10.197 14.953)",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-question-mark.de939cb6.svg";
export { ForwardRef as ReactComponent };